import {
  useWorkOrderTrackPageConfigContext,
  WorkOrderTrackPageConfigContextProvider
} from "./WorkOrderTrackPageConfigContext";

export default useWorkOrderTrackPageConfigContext;
export { WorkOrderTrackPageConfigContextProvider };
